import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/ui';

// The phone app's release notes, imported straight from where they are already
// maintained. Copying them into this app's locale files would guarantee they go
// stale the first time a release ships without someone remembering this page.
import changelog from '@app/assets/changelog.json';

interface Release {
    version: string;
    date: string;
    changes: string[];
}

const RELEASES = (changelog as Release[]).slice(0, 3);

export const WhatsNew: React.FC = () => {
    const { t, i18n } = useTranslation();

    const formatDate = (iso: string): string => {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return iso;
        return d.toLocaleDateString(i18n.language === 'po' ? 'pl' : i18n.language, {
            year: 'numeric', month: 'long', day: 'numeric',
        });
    };

    return (
        <Section
            id="whatsnew"
            tint
            eyebrow={t('web.whatsnew.eyebrow')}
            title={t('web.whatsnew.title')}
            sub={t('web.whatsnew.sub')}
        >
            <div className="grid grid--3">
                {RELEASES.map((release) => (
                    <article className="tile release" key={release.version}>
                        <div className="release__head">
                            <span className="release__version">{release.version}</span>
                            <span className="release__date">{formatDate(release.date)}</span>
                        </div>
                        {/* changelog.json is written in English only. Saying so is
                            better than letting a Croatian reader assume the
                            translation simply failed. */}
                        <ul className="release__list" lang="en">
                            {release.changes.slice(0, 3).map((change, index) => (
                                <li key={index}>
                                    <span className="release__bullet" aria-hidden="true">•</span>
                                    <span>{change}</span>
                                </li>
                            ))}
                        </ul>
                    </article>
                ))}
            </div>
        </Section>
    );
};
